/*
 * Site Container Max Width
 */

const container = '1920px';

export default container;
